var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconDocumentLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconDocument",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1706.235 1807.059H350.941V112.94h903.53v451.765h451.764v1242.353Zm-338.823-1670.74 315.443 315.447h-315.443V136.32Zm402.182 242.487L1440.372 49.58C1408.296 17.62 1365.717 0 1320.542 0H238v1920h1581.175V498.635c0-45.176-17.618-87.755-49.58-119.83ZM576.823 1242.353h790.589v-112.94H576.823v112.94Zm0-451.765h903.53V677.647h-903.53v112.941Zm0 677.647h451.765v-112.941H576.823v112.941Zm0-451.764h677.648V903.53H576.823v112.941Zm0-451.765h451.765V451.765H576.823v112.941Z",
      fillRule: "evenodd"
    })));
  }
}
IconDocumentLine.glyphName = 'document';
IconDocumentLine.variant = 'Line';
IconDocumentLine.displayName = 'IconDocumentLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconDocumentLine.propTypes = {
  ...SVGIcon.propTypes
};
IconDocumentLine.allowedProps = [...SVGIcon.allowedProps];
export default IconDocumentLine;
export { IconDocumentLine };